import React from 'react';
import { Button, IconButton, useDisclosure } from '@chakra-ui/react';
import { FaInfoCircle } from 'react-icons/fa';
import InfoCILPointsModal from './InfoCILPointsModal';
import { CIL_POINTS_LABEL } from '../../utils/cilPoints';

/**
 * Trigger informativo sui CIL Points: apre modale con link alla guida pubblica.
 * @param {'icon' | 'link'} variant
 * @param {'purple' | 'light' | 'account' | 'hero'} tone — contesto colore del trigger
 */
const InfoCILPoints = ({ variant = 'link', tone = 'purple', size = 'sm' }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const linkColor =
    tone === 'account'
      ? '#9ec9de'
      : tone === 'hero'
        ? 'white'
        : tone === 'light'
          ? 'purple.700'
          : 'purple.600';

  const linkHover =
    tone === 'account' || tone === 'hero'
      ? { color: '#ffcc00', textDecoration: 'underline' }
      : {};

  return (
    <>
      {variant === 'icon' ? (
        <IconButton
          aria-label={`Informazioni su ${CIL_POINTS_LABEL}`}
          icon={<FaInfoCircle />}
          variant="ghost"
          size={size}
          color={tone === 'account' ? '#9ec9de' : linkColor}
          _hover={{ bg: tone === 'account' ? 'whiteAlpha.200' : 'purple.50' }}
          onClick={onOpen}
        />
      ) : (
        <Button
          variant="link"
          type="button"
          fontSize={size === 'xs' ? 'xs' : 'sm'}
          fontWeight="semibold"
          color={linkColor}
          _hover={linkHover}
          display="inline-flex"
          alignItems="center"
          gap={1}
          h="auto"
          minH="auto"
          p={0}
          onClick={onOpen}
          leftIcon={<FaInfoCircle />}
        >
          Cosa sono i {CIL_POINTS_LABEL}?
        </Button>
      )}

      <InfoCILPointsModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default InfoCILPoints;
